module.exports = __webpack_public_path__ + "img/star-102-7.d1d4e224.png";